export const LABELS = {
  numberOfApplicants: "Number of applicants",
};
